import { pageData, PageOptionsMeta } from "../../../constants/pagedata";
import { TaskOption } from "../tasks";

export const StepFour=function(props:{createStarted:boolean, pageSelected:string, contentSelected:string[], taskTitle:string, confirmCreateClick:Function, updateOptions:Function, pageOptions:TaskOption[]}){

    let allComplete=checkComplete(props.pageSelected, props.contentSelected, props.taskTitle);
	let createDisabled=allComplete===false||props.createStarted===true;
	let createMsg=allComplete===true&&props.createStarted===false?"Click 'Create Task' to Confirm":"";

	return(
		<div className='teachers-taskcreater-step'>
			<hr />
			<h3>Step 4{allComplete&&'  - Complete'}
			</h3>
      		{!allComplete&&<p>Complete the other steps first</p>}
			<PageOptions 
				pageSelected={props.pageSelected}
				pageOptions={props.pageOptions} 
				allComplete={allComplete}
				updateOptions={props.updateOptions} />
			{createMsg!==''&&<p>{createMsg}</p>}
			<button disabled={createDisabled} onClick={()=>{props.confirmCreateClick();}} className='teachers-taskcreater-button teachers-button'>Create Task</button>
		</div>
	)
};

function checkComplete(pageSelected:string, contentSelected:string[], taskTitle:string){
	let allComplete=true;
	if(pageSelected==='')allComplete=false;
	let contentGroup=0;
	if(pageSelected!=='')contentGroup=pageData[pageSelected].contentGroup;
	if(contentGroup!==0&&contentSelected[0]==='')allComplete=false;
	if(taskTitle==='')allComplete=false;
    return allComplete;
}

const PageOptions=function(props:{pageSelected:string, pageOptions:TaskOption[], allComplete:boolean, updateOptions:Function}){
    if(!props.allComplete)return null;
    if(!pageData[props.pageSelected].pageOptionsMeta)return null;

    let options=pageData[props.pageSelected].pageOptionsMeta.map((option:PageOptionsMeta,index:number)=>{
        let myKey='options-'+index;
        return <OptionSet key={myKey} optionMeta={option} pageOptions={props.pageOptions} optionsIndex={index} updateOptions={props.updateOptions}/>
    });

    return(
        <div>
            {options}
        </div>
    )
};

const OptionSet=function(props:{optionMeta:PageOptionsMeta, pageOptions:TaskOption[], optionsIndex:number, updateOptions:Function}){
	let indexSelected=0;
	let optID='';
	for(let i=0;i<props.pageOptions.length;i++){
		if(props.optionMeta.optionsId===props.pageOptions[i].optID){
			indexSelected=props.pageOptions[i].optVal;
			optID=props.pageOptions[i].optID;
		}
	}
	if(optID==='')return null;
	let myOptionBoxes=props.optionMeta.options.map((option,index)=>{
		let myKey='option-'+index;
		let isSelected=index===indexSelected;
		return <OptionCheckBox key={myKey} option={option} isSelected={isSelected} boxClick={()=>{props.updateOptions(optID,index);}} />
	})

    return(
        <div className='teachers-taskcreater-options'>
            <span className='teachers-taskcreater-optionboxestext'>{props.optionMeta.label}</span>
            <span className='teachers-taskcreater-checkboxexplain'>{props.optionMeta.explain}</span>
            <div className='teachers-taskcreater-options-list'>
                {myOptionBoxes}
            </div>
        </div>
    )
  };

const OptionCheckBox=function(props:{isSelected:boolean, boxClick:Function, option:{optionIndex:number, optionDesc:string}}){
	return(
		<div>
			<input className='teachers-taskcreater-checkbox' type="checkbox" checked={props.isSelected} onChange={()=>{props.boxClick();}}></input>
			<span className='teachers-taskcreater-checkboxtext'>{props.option.optionDesc}</span>
		</div>
	)
};